import { EstimatRequestResponse } from '@/models/EstimateRequestResponse';
import { Site } from '@/models/Site';
import { MutationTree } from 'vuex';
import { EstimateRequestState } from '.';
import { ESTIMATE } from './mutation-types';
import { EstimateFormStep } from './state';

export const mutations: MutationTree<EstimateRequestState> = {
    [ESTIMATE.SET_OBJET](state, objet: string){
        state.objet = objet;
    },
    [ESTIMATE.SET_DESCRIPTIF](state, descriptif: string){
        state.descriptif = descriptif;
    },
    [ESTIMATE.SET_DATE](state, date: string){
        state.date = date;
    },
    [ESTIMATE.SET_CHANTIER](state, site: Site){
        state.site = site;
    },
    [ESTIMATE.SET_LOADING](state, isLoading: boolean){
        state.isLoading = isLoading;
    },
    [ESTIMATE.SET_STEP](state, step: EstimateFormStep){
        state.step = step;
    },
    [ESTIMATE.SET_SUCCESS](state, success: boolean){
        state.success = success;
    },
    [ESTIMATE.SET_ERROR](state, error: Error){
        state.error = error;
    },
    [ESTIMATE.SET_RESPONSE](state, response: EstimatRequestResponse){
        state.response = response;
    },
    [ESTIMATE.SET_EDITING](state, isEditing: boolean){
        state.isEditing = isEditing;
    },
    [ESTIMATE.SET_EDITING_ID](state, editingEstimateId?: number){
        state.editingEstimateId = editingEstimateId;
    },


    [ESTIMATE.RESET_ESTIMATE](state){
        state.site = undefined;
        state.objet = '';
        state.descriptif = '';
        state.date = '';
        state.isLoading = false;
        state.error = undefined;
        state.success = false;
        state.step = EstimateFormStep.first;
        state.isEditing = false;
        state.editingEstimateId = undefined;
        state.documents = [];

    },
    [ESTIMATE.SET_FILES](state, document: File[]) {
        state.documents = document;
    },
    [ESTIMATE.ADD_FILE](state, document: File) {
        state.documents = [...state.documents, document];
    },
    [ESTIMATE.REMOVE_FILE](state, document: File) {
        state.documents = state.documents.filter(f => f.name !== document.name );
    },
};
